import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext";
import { forgotPassword } from "../api";
import { TextField, Button, Stack } from "@newulife/common";
import validator from 'validator';

export default function Forgot() {
  const navigate = useNavigate();
  const {
    state: {
      locale,
      dictionary: { forgot: c_forgot },
    },
    actions: { setMessage },
  } = useAppContext();
  const [id, set_id] = useState("");
  const [email, set_email] = useState("");
  const [emailError, set_emailError] = useState(false);
  const [
    text1,
    text_subtitle,
    text_distId,
    text_email,
    text_cancel,
    text_successMessage,
    text_errorMessage,
    text_submit,
    text_invalidEmailMessage,
  ] = c_forgot;
  const text_forgotPassword = text1.slice(0, -1); // remove '?'
  // Disable button if no email or email is invalid
  const isSubmitDisabled = !email || !validateEmail(email);

  function handleSubmit() {
    // Validate email before submitting
    if (!email) {
      set_emailError(true);
      return;
    }
    
    if (!validateEmail(email)) {
      set_emailError(true);
      return;
    }

    // If we get here, email is valid
    forgotPassword({ email, locale })
      .then((response) => {
        setMessage({ text: text_successMessage, type: "info" });
      })
      .catch(() => {
        setMessage({ text: text_errorMessage });
      })
      .finally(() => navigate("/login"));
  }

  function validateEmail(email) {
    if (!email) return false;
    return validator.isEmail(email);
  }

  function handleEmailChange(e) {
    const { value } = e.target;
    set_email(value);

    if (value) {
      const isValid = validateEmail(value);
      set_emailError(!isValid);
    } else {
      set_emailError(false);
    }
    // Don't show errors while typing, only on blur
  }

  return (
    <section>
      <h1 className="text-center mb-40 mt-40">{text_forgotPassword}</h1>
      <div className="form-max flex-20 column">
        <p>{text_subtitle}</p>
        <TextField
          id="email"
          label={text_email.name}
          name="email"
          type="text"
          isErrored={emailError}
          errorText={text_invalidEmailMessage?.name}
          onChange={handleEmailChange}
          variant="filled"
        />
        <Stack direction="row" spacing={2} justifyContent="center" className="mt-20">
          <Button 
            variant="outlined" 
            type="button"
            onClick={() => navigate('/login')}
          >
            {text_cancel}
          </Button>
          <Button onClick={handleSubmit} disabled={isSubmitDisabled}>
            {text_submit}
          </Button>
        </Stack>
      </div>
    </section>
  );
}
